import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material'

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'transparent',
    padding: 0,
    margin: 0,
  },
}))

export const CustomTooltip: React.FC<TooltipProps> = (props) => {
  return (
    <StyledTooltip
      placement="bottom"
      disableInteractive
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -12],
            },
          },
        ],
      }}
      {...props}
    />
  )
}